export default "__VITE_ASSET__d6d4ba8b__"